import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CategoryDto, Language, SupporterEditDto, Team, SupporterDto } from '../../../shared/model';

@Component({
  selector: 'app-edit-supporter',
  templateUrl: './edit-supporter.component.html',
  styleUrls: ['../../../shared/styles/edit-modal.css',
    './edit-supporter.component.css',
    '../../../shared/styles/translation.css']
})
export class EditSupporterComponent {

  @Input() categories: CategoryDto[];
  @Input() languages: Language[];
  @Input() teams: Team[];
  @Input() supporter: SupporterEditDto;
  @Input() technicians: SupporterDto[];

  dropdownData: SupporterDto[] = [];
  myForm: FormGroup;
  emailMissing = false;
  teamMissing = false;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder) {
    this.createForm();
  }

  createForm() {
    this.myForm = this.formBuilder.group({
      Technician: { Email: '', FirstName: '', LastName: '' },
      FirstName: '',
      LastName: '',
      Team: <Team>{},
      Languages: [],
      Categories: []
    });
  }

  initializeForm() {
    this.dropdownData = this.technicians;
    if (this.supporter) {
      this.setFormValues();
    } else {
      this.myForm.controls['Languages'].setValue(new Array());
      this.myForm.controls['Categories'].setValue(new Array());
    }
  }

  verifyChanges() {
    this.checkTeam();
    this.checkEmail();

    if (!this.emailMissing && !this.teamMissing) {
      this.submitForm();
    }
  }

  checkEmail() {
    this.emailMissing = !(
      !!this.myForm.get('Technician').value
      && !!this.myForm.get('Technician').value.Email
      && this.myForm.get('Technician').value.Email.trim() !== ''
    );
  }

  checkTeam() {
    this.teamMissing = !(
      !!this.myForm.get('Team').value
      && !!this.myForm.get('Team').value.Id
      && this.myForm.get('Team').value.Id.trim() !== ''
    );
  }

  submitForm() {
    this.activeModal.close(this.myForm.value);
  }

  handleFilter(value: string) {
    if (value.length >= 1) {
      this.dropdownData = this.technicians.filter((s) => s.Email.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
      this.dropdownData = this.technicians;
    }
  }

  assignName(value: any) {
    if (value) {
      this.myForm.get('FirstName').setValue(value.FirstName);
      this.myForm.get('LastName').setValue(value.LastName);
    } else {
      this.myForm.get('FirstName').setValue('');
      this.myForm.get('LastName').setValue('');
    }

    this.checkEmail();
  }

  setCheckbox(id: string, formArray: string) {
    const currentValues = [...this.myForm.get(formArray).value];
    const index = currentValues.indexOf(id);
    if (index >= 0) {
      currentValues.splice(index, 1);
    } else {
      currentValues.push(id);
    }

    this.myForm.get(formArray).setValue(currentValues);
  }

  isItemChecked(id: string) {
    if (!this.supporter) {
      return false;
    } else {
      return this.supporter.CategoryIds.indexOf(id) !== -1 || this.supporter.LanguageIds.indexOf(id) !== -1;
    }
  }

  private setFormValues() {
    const technician = {
      Email: this.supporter.Email,
      FirstName: this.supporter.FirstName,
      LastName: this.supporter.LastName
    };

    this.myForm.controls['Technician'].setValue(technician);
    this.myForm.controls['Team'].setValue(this.teams.find(t => t.Id === this.supporter.TeamId));
    this.myForm.controls['FirstName'].setValue(this.supporter.FirstName);
    this.myForm.controls['LastName'].setValue(this.supporter.LastName);
    this.myForm.controls['Languages'].setValue([...(this.supporter.LanguageIds || [])]);
    this.myForm.controls['Categories'].setValue([...(this.supporter.CategoryIds || [])]);
  }
}
